import { createFileRoute, Outlet } from '@tanstack/react-router';

const Component = () => {
  return (
    <div className="relative flex min-h-screen flex-col bg-background-lighter px-4">
      <Outlet />
    </div>
  );
};

export const Route = createFileRoute('/_authenticated/_nosidebar-layout')({
  component: Component,
});
